import { render } from "./LanguageSettings.vue?vue&type=template&id=12af2c04"
import script from "./LanguageSettings.vue?vue&type=script&lang=js"
export * from "./LanguageSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__